exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conversation[data-v-dcf79a54] {\n  align-items: center;\n  height: calc(100% - 60px);\n  width: 436px;\n  position: fixed;\n  z-index: 3;\n  right: 0;\n  top: 60px;\n  background-color: #fafafa;\n}\n[data-v-dcf79a54] [type='submit'],\n[type='select'][data-v-dcf79a54] {\n  padding: 0;\n}\n.conversation[data-v-dcf79a54] {\n  font-weight: normal;\n}\n[data-v-dcf79a54] .mdc-circular-progress {\n  position: absolute;\n  top: calc(50% - 64px);\n  right: calc(50% - 64px);\n}\n", ""]);

// exports
